import React, {Component} from 'react';
import {BrowserRouter as Router, Route} from "react-router-dom";
import Home from './Home';
import './App.css';
import Document from "./Document";
import ImportBill from "./Document/ImportBill";
import ActivationCode from "./Activity/ActivationCode";
import AppHomeActivationCode from "./Activity/AppHomeActivationCode";
import VipAgreement from "./VipAgreement";
import AuthAgreement from "./AuthAgreement";
import Privacy from "./Privacy/2024.09.23";
import Privacy_23943 from "./Privacy/2025.02.20";
import iPrivacy from "./Privacy/2025.09.18/ios";
import aPrivacy from "./Privacy/2025.09.18/android";
import iPrivacy20251223 from "./Privacy/2025.12.23/ios";
import aPrivacy20251223 from "./Privacy/2025.12.23/android";
import iPrivacy20260403 from "./Privacy/2026.4.3/ios";
import aPrivacy20260403 from "./Privacy/2026.4.3/android";
import UnderagePrivacy from "./Privacy/UnderagePrivacy/2025.09.18"
import ThirdSharedList from "./Privacy/ThirdSharedList"
import ThirdSharedListBasics from "./Privacy/ThirdSharedList/index-ios.jsx"
import Join from "./Join";
import RichPrivacy from "./RichPrivacy";
import Roadmap from "./Roadmap";
import Roadmap1 from "./Roadmap/1";
import Roadmap2 from "./Roadmap/2";
import RichVipAgreement from "./RichVipAgreement";
import Business from "./Business";
import Footer from "./Home/Footer";
import Header from "./Home/Header";
import {enquireScreen} from "enquire-js";
import AppHomeActivationCode1 from "./Activity/AppHomeActivationCode/index1";
import AndroidDownload from "./CXB/AndroidDownload";
import Ohos from "./CXB/Ohos";
import CodeMate from "./CodeMate";
import {ThemeProvider} from "./contexts/ThemeContext";

let isMobile;

enquireScreen((b) => {
    isMobile = b;
});


class App extends Component {
    state = {
        isMobile,
    }

    componentDidMount() {
        enquireScreen((b) => {
            this.setState({
                isMobile: !!b,
            });
        });
    }

    render() {
        return (
            <ThemeProvider>
                <Router>
                    <div>
                        <Header isMobile={this.state.isMobile}/>
                        <Route exact path="/iPrivacy_250619" component={iPrivacy}/>
                        <Route exact path="/aPrivacy_250619" component={aPrivacy}/>
                        <Route exact path="/iPrivacy20251223" component={iPrivacy20251223}/>
                        <Route exact path="/aPrivacy20251223" component={aPrivacy20251223}/>
                        <Route exact path="/iPrivacy20260403" component={iPrivacy20260403}/>
                        <Route exact path="/aPrivacy20260403" component={aPrivacy20260403}/>

                        <Route exact path="/underage_privacy" component={UnderagePrivacy}/>
                        <Route exact path="/rich_privacy" component={RichPrivacy}/>

                        <Route exact path="/" component={Home}/>
                        <Route exact path="/privacy" component={Privacy}/>
                        <Route exact path="/Privacy_23943" component={Privacy_23943}/>
                        <Route exact path="/ThirdSharedList" component={ThirdSharedList}/>
                        <Route exact path="/ThirdSharedListBasics" component={ThirdSharedListBasics}/>
                        <Route exact path="/activation_code_activity" component={ActivationCode}/>
                        <Route exact path="/document" component={Document}/>
                        <Route exact path="/document/import_bill" component={ImportBill}/>
                        <Route exact path="/roadmap" component={Roadmap}/>
                        <Route exact path="/roadmap-1" component={Roadmap1}/>
                        <Route exact path="/roadmap-2" component={Roadmap2}/>
                        <Route exact path="/auth_agreement" component={AuthAgreement}/>
                        <Route exact path="/vip_agreement" component={VipAgreement}/>
                        <Route exact path="/rich_vip_agreement" component={RichVipAgreement}/>
                        <Route exact path="/app_home_activation_code" component={AppHomeActivationCode}/>
                        <Route exact path="/app_home_activation_code_vip" component={AppHomeActivationCode1}/>
                        <Route exact path="/join" component={Join}/>
                        <Route exact path="/business" component={Business}/>
                        <Route exact path="/androidDownload" component={AndroidDownload}/>
                        <Route exact path="/ohosfresh" component={Ohos}/>
                        <Route exact path="/codeMate" component={CodeMate}/>
                        <Footer/>
                    </div>
                </Router>
            </ThemeProvider>
        );
    }
}

export default App;
